import { Box, Drawer, Modal } from '@mui/material'
import { SelectPlayListActionContent } from './SelectPlayListActionContent'
import { SelectPlayListActionProps } from './type'

const modalStyle = {
  position: 'absolute' as 'absolute',
  top: '45%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 350,
  paddingX: 2,
  outline: 'none',
  borderRadius: '0 6px 0 6px',
}

export const SelectPlayListAction = ({ isOpen, ...props }: SelectPlayListActionProps) => {
  return (
    <>
      <Drawer anchor='bottom' open={isOpen} onClose={props.onClose} sx={{ display: { xs: 'block', sm: 'none' } }}>
        <SelectPlayListActionContent {...props} />
      </Drawer>
      <Modal
        open={isOpen}
        onClose={props.onClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
        sx={{ display: { xs: 'none', sm: 'block' } }}
      >
        <Box sx={modalStyle}>
          <Box role='presentation'>
            <SelectPlayListActionContent {...props} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
